var map = {
	"./Modules/Casino/casino-module/casino.module": [
		"../../../../../src/app/Modules/Casino/casino-module/casino.module.ts",
		"common"
	],
	"./Modules/CrashGames/crash-games-module/crash-games.module": [
		"../../../../../src/app/Modules/CrashGames/crash-games-module/crash-games.module.ts",
		"common",
		"crash-games.module"
	],
	"./Modules/HeaderGame/header-game-module/header-game.module": [
		"../../../../../src/app/Modules/HeaderGame/header-game-module/header-game.module.ts",
		"header-game.module"
	],
	"./Modules/Home/home-module/home.module": [
		"../../../../../src/app/Modules/Home/home-module/home.module.ts",
		"common",
		"home.module"
	],
	"./Modules/LiveCasino/live-casino-module/live-casino.module": [
		"../../../../../src/app/Modules/LiveCasino/live-casino-module/live-casino.module.ts",
		"live-casino.module"
	],
	"./Modules/NumberGames/number-games-module/number-games.module": [
		"../../../../../src/app/Modules/NumberGames/number-games-module/number-games.module.ts",
		"common",
		"number-games.module"
	],
	"./Modules/TvBet/tv-bet-module/tv-bet.module": [
		"../../../../../src/app/Modules/TvBet/tv-bet-module/tv-bet.module.ts",
		"tv-bet.module"
	],
	"./Modules/User/user-module/user.module": [
		"../../../../../src/app/Modules/User/user-module/user.module.ts",
		"user.module"
	],
	"./Modules/VirtualBetting/virtual-betting-module/virtual-betting.module": [
		"../../../../../src/app/Modules/VirtualBetting/virtual-betting-module/virtual-betting.module.ts",
		"common",
		"virtual-betting.module"
	],
	"./Modules/Virtuals/virtuals-module/virtuals.module": [
		"../../../../../src/app/Modules/Virtuals/virtuals-module/virtuals.module.ts",
		"common",
		"virtuals.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main